import { Flex, RadioGroup, Radio, Box } from "@chakra-ui/react";
import PercentField from "../PercentField";

interface FloatingInterestRateResult {
    LoanType: string;
    InterestRate: string;
    IsActive: boolean;
}

interface FloatingInterestRateProps {
    onChange: (result: FloatingInterestRateResult) => void;
    isInvalid?: boolean;
    field: any;
    value: FloatingInterestRateResult;
    isDisabled: boolean;
}

const FloatingInterestRate = ({
    onChange,
    isInvalid,
    field,
    value,
    isDisabled,
}: FloatingInterestRateProps) => {
    if (!value) {
        value = {
            LoanType: "",
            InterestRate: "",
            IsActive: false,
        };
    }

    const handleRadioChange = (loanType: string) => {
        const newValue = {
            ...value,
            LoanType: loanType,
        };
        onChange(newValue);
    };

    const handleInputChange = (interestRate: string) => {
        const newValue = {
            ...value,
            InterestRate: interestRate,
        };
        onChange(newValue);
    };

    return (
        <Flex alignItems="center" gap={2} justifyContent="space-between">
            <RadioGroup
                onChange={(value) => {
                    handleRadioChange(value);
                }}
                value={value.LoanType ?? ""}
                isDisabled={isDisabled}
            >
                <Flex gap={2}>
                    {field.options.map((option: string) => (
                        <Radio
                            key={option}
                            value={option}
                            isChecked={value.LoanType === option}
                            style={{
                                backgroundColor:
                                    option === "Floating" &&
                                    value.LoanType === "Floating"
                                        ? "#1F2122"
                                        : option === "Fixed" &&
                                            value.LoanType === "Fixed"
                                          ? "#1F2122"
                                          : "",
                            }}
                        >
                            {option}
                        </Radio>
                    ))}
                </Flex>
            </RadioGroup>

            <Box>
                <PercentField
                    value={value.InterestRate ?? ""}
                    onChange={(val) => handleInputChange(val)}
                    isInvalid={isInvalid}
                    disabled={isDisabled}
                />
            </Box>
        </Flex>
    );
};

export default FloatingInterestRate;
